export const GET_RECORDED_ECG_ARRHYTHMIA_WINDOW =
  'recordedEcgArrhythmiaWindow/getPatientRecordedEcgArrhythmiaWindow'
